import {Cookie} from "../../helpers/Cookie";

export const optimalCookies    = [
    'intercom-id-jxsj5th2',
    'intercom-state',
    'mkra_ctxt',
    'VISITOR_INFO1_LIVE',
    'YSC',
    'PREF',
    'NID',
    'DV',
    'CONSENT',
    'UULE',
    '1P_JAR',
    'ads/ga-audiences',
    'ads/user-lists/#',
    'IDE',
    'GPS'];

export class CookiePreferences
{
    /**
     * CookiePreferences constructor
     */
    constructor() {
        this.cookie         = new Cookie();
        this.$savedAlert    = $('.js-cookie-preferences-alert');
        const $preference   = $('.js-cookies-preferences');
        $preference.on('change', e => this._togglePreference(e));
    }

    /**
     * set preference of the user
     * @param value
     * @private
     */
    _setPreference(value) {
        this.cookie.set('preference', 'true');
        this.cookie.set('privacyLevel', value);

        if ('minimal' === value) this._clearOptimalCookies();
    }


    /**
     * hide cookienotice
     * @private
     */
     _exitCookieModal() {
        this._setPreference('minimal');
    }


    /**
     * set cookies to minimal and go to info page
     * @param e
     * @private
     */
    _goToInfoPage(e) {
        e.preventDefault();
        this._setPreference('minimal');
        this._redirectTo('/privacy/');
    }

    /**
     * accepts the optimal cookies
     * @param e
     * @private
     */
    _acceptOptimalCookies(e) {
        e.preventDefault();
        this.cookie.set('preference', 'true');
        this.cookie.set('privacyLevel', 'optimal');
        location.reload();
    }

    /**
     * sets which one of the two cookies preferences the user has chosen
     * @param e
     * @private
     */
     _togglePreference(e) {
        this.$savedAlert.hide();
        const $input = $(e.currentTarget);
        const preference = $input.val();
        this._setPreference(preference);

        this.$savedAlert.slideToggle();
    }

    /**
     * clears the optimal cookies
     * @private
     */
    _clearOptimalCookies() {
        for (let index in optimalCookies) {
            this.cookie.clear(optimalCookies[index]);
        }
    }


    /**
     * Redirects user
     * @param url
     */
    /* istanbul ignore next */
    _redirectTo(url) {
        window.location.href = url;
    }

}
